<template>
    <div class="modal fade" id="appMgrApplicationDetailModal" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv" style="min-width: 700px; max-width: 700px; max-height: max-content;">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv">
                        <div class="modal-header-text-scv">
                            詳細情報
                        </div>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div class="main-setting-table">
                        <div class="main-category-text">
                            <span class="main-category-font">アプリケーション情報</span>
                        </div>
                    </div>

                    <div class="scv-app-detail-area flex-row">
                        <div>
                            <template v-if="0 != basicInfo.iconUrl.length">
                                <img :src="basicInfo.iconUrl" class="scv-app-detail-area-icon" style="margin-right: 16px;" />
                            </template>
                            <template v-else>
                                <div class="scv-app-detail-area-icon" style="margin-right: 16px;"></div>
                            </template>

                        </div>
                        <div class="d-flex flex-column flex-grow-1" style="margin-top: 16px; row-gap: 16px;">
                            <div class="scv-app-item-box">
                                <div class="scv-app-detail-title-box" style="min-width: 10em;">
                                    アプリケーション名：
                                </div>
                                <div class="scv-app-detail-input-box">
                                    <span class="scv-app-detail-input">{{basicInfo.appName}} </span>
                                </div>
                            </div>
                            <div class="scv-app-item-box">
                                <div class="scv-app-detail-title-box" style="min-width: 10em;">
                                    提供元：
                                </div>
                                <div class="scv-app-detail-input-box">
                                    <span class="scv-app-detail-input">{{basicInfo.author}} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="scv-app-detail-area flex-column" style="row-gap: 16px; margin-top: 0px;">
                        <div class="scv-app-item-box">
                            <div class="scv-app-detail-title-box">
                                パッケージ名：
                            </div>
                            <div class="scv-app-detail-input-box">
                                <span class="scv-app-detail-input">{{basicInfo.packageName}} </span>
                            </div>
                        </div>
                        <div class="scv-app-item-box">
                            <div class="scv-app-detail-title-box">
                                カテゴリ：
                            </div>
                            <div class="scv-app-detail-input-box">
                                <span class="scv-app-detail-input">{{basicInfo.category}} </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal">閉じる</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Vue } from 'vue-class-component';
    import { cloneDeep } from 'lodash';
    import $ from "jquery";
    import { AndroidAppMgrApplicationBasicJsonExtend } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrApplicationSetting';

    export default class AppMgrApplicationDetailModal extends Vue {

        // 発行済みID
        private static AppMgrApplicationDetailModalIDNumber = 0;
        // 自身のID
        private myAppMgrApplicationDetailModalID = "";

        // メンバ変数
        private basicInfo = new AndroidAppMgrApplicationBasicJsonExtend();

        /**
         * @brief   created
         */
        public created() {
            // 発行済みIDをインクリメントして他のメッセージダイアログとIDが重複しないようにする
            AppMgrApplicationDetailModal.AppMgrApplicationDetailModalIDNumber += 1;
            this.myAppMgrApplicationDetailModalID = 'appMgrApplicationDetailModal' + AppMgrApplicationDetailModal.AppMgrApplicationDetailModalIDNumber.toString();
        }

        /**
         * @brief	mounted
         * @note    インスタンスが DOM 要素にマウントされた後
         * @return	なし
         */
        public mounted(): void {
            $('#appMgrApplicationDetailModal').attr('id', this.myAppMgrApplicationDetailModalID);

            const el = document.getElementById(this.GetID());
            if(null != el) {
                el.addEventListener('hidden.bs.modal', () => {
                    this.basicInfo = new AndroidAppMgrApplicationBasicJsonExtend();
                });
            }
        }

        /**
         * @brief   データを設定します
         */
        public SetData(basicInfo: AndroidAppMgrApplicationBasicJsonExtend): void {
            this.basicInfo = cloneDeep(basicInfo);
        }

        /**
         * @brief   割り振られたIDを取得
         */
        public GetID(): string {
            return this.myAppMgrApplicationDetailModalID;
        }
    }
</script>

<style scoped>
    /* 横書きの情報box */
    .scv-app-item-box {
        display: flex;
        flex-direction: row;
    }

    /* タイトル */
    .scv-app-detail-title-box {
        height: 32px; /* タイトルを中央寄せするために32pxをセット */
        display: flex;
        align-items: center;
        min-width: 11em;
        justify-content: end; /* 右寄せ */
    }

    /* テキストエリア */
    .scv-app-detail-input-box {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        min-height: 32px;
        margin-left: 4px;
        border-bottom: 1px solid #E1E6F5;
        width: 0px; /* 改行するために指定が必要 */
    }

        /* テキストエリア（最後の行は下線なし） */
        .scv-app-detail-input-box.last-row-box {
            border-bottom: none !important;
        }

    /* テキスト */
    .scv-app-detail-input {
        padding: 0px 8px;
        word-wrap: break-word; /* はみ出る分は改行 */
    }

    /* カテゴリ内のエリア */
    .scv-app-detail-area {
        display: flex;
        flex-grow: 1;
        margin: 24px 0px 24px 16px;
    }

    /* アイコン */
    .scv-app-detail-area-icon {
        height: 120px;
        width: 120px;
        border-radius: 26px;
        border: 0.5px solid #E6EBF0;
    }
</style>
